<template>
    <div id="forums">
        
        <v-container>

            <v-layout column>

                <v-flex xs12 md6 class="pt-2 pb-4">
                    <span class="display-2">Forums</span>
                    <span class="headline font-weight-thin">Talk about the Roads</span>
                </v-flex>

                <v-flex xs12> <!-- Card Container -->

                    <v-layout justify-center align-center wrap>

                        <template v-for="items in cardData">
                            <v-flex xs12 sm6 md4 :key="items.specialID">
                                <v-card @click.native="betterForums(items)" max-width="438px" max-height="402px" class="ma-2" style="border-radius:20px; overflow:hidden;" hover> <!-- Overall Card -->

                                    <v-responsive> <!-- the image for the card -->
                                        <v-img :src="items.image" max-width="438px" height="201px"></v-img>
                                    </v-responsive>

                                    <v-card-title class="pt-1 pb-0"> <!-- Card Category and type -->
                                        <span class="display-1">{{items.category}}</span>
                                        <span class="headline pt-1 font-weight-light">{{items.type}}</span>
                                    </v-card-title>

                                    <span> <!-- Where the userfield and content is -->

                                        <v-list class="pa-0"> <!-- Avatar stuff -->
                                            <v-list-tile avatar>

                                                <v-list-tile-avatar>
                                                    <img :src="items.userAvatar" alt="">
                                                </v-list-tile-avatar>

                                                <v-list-title class="font-weight-light" style="font-size:14px">{{items.userName}}</v-list-title>
                                                    <!-- <span>{{items.date}}</span> -->
                                            </v-list-tile>
                                        </v-list>

                                        <p class="subheading mx-4 grey--text text--lighten-1">
                                            {{items.misc}}
                                        </p> <!--Actual Word Content -->
                                    </span>

                                </v-card>
                            </v-flex>
                        </template>

                    </v-layout>

                </v-flex>

            </v-layout>

        </v-container>

    </div>
</template>

<script>
import {database,storage,auth} from '@/fb.js';
import {bus} from '@/main.js';
const storageReference = storage.ref();
export default {
    created() {
        database.collection('Pins').onSnapshot(data => {

            let temp = [];
            
            data.forEach(function(doc) {
                temp.push(doc.data());
            });

            temp.forEach(data => {
                storageReference.child(data.image).getDownloadURL().then(url => {
                    data.image = url;
                });
            });
            this.cardData = temp;
        });
    },
    data() {
        return {
            cardData: [],
            dummyData: [
                {image: require('@/assets/default.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SupaWoomyXOXO",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default2.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"LimeWireWoomy",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default3.jpg'),category:"Accident",type:"Pile-up",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SplatUmom",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SupaWoomyXOXO",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default2.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"LimeWireWooqmy",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default3.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SplatUmqom",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SupaWoomsyXOXO",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default2.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"LimeWirsxeWoomy",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
                {image: require('@/assets/default3.jpg'),category:"Danger",type:"Forest Fire",userProfile:require('@/assets/user.jpg'),date:'19/04/16',userName:"SplatUxamom",content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris purus lectus, vehicula ac tortor quis, bibendum dictum turpis. Maecenas ornare blandit lectus quis feugiat. Cras efficit..."},
            ]
        }
    },
    methods: {
        betterForums(data) {
            console.log('card clicked! What the hell!');
            bus.$emit('categoryChange','Forums-Expanded-Page');
            bus.$emit('handData',data);
        }
    }
}
</script>

<style scoped>
    .v-card__title {
        position: relative;
    }

    .v-card__title::after {
        position: absolute;
        content:"";
        width: 75%;
        height: 1px;
        border-bottom: 1px solid #77FFC6;
        bottom: -10%;
    }
</style>
